import { Theme } from "../../constants";

export default {
    dropdownMenu: {
        width: "auto",
        margin: "5px 0px 0px 0px",
        maxHeight: "300px",
        overflow: "overlay",
    },
    searchInput: {
        position: 'absolute',
        left: '-9999px',
    },
    disabledStyle: {
        background: Theme.DISABLED_INPUT,
    },
    dropdownActiveItem: {
        background: Theme.PRIMARY,
        color: Theme.TEXT_WHITE
    },
    dropdownHoveredItem:{
        background: "#E5EEFA"       
    }
}